import React from "react";
import Gallery from "react-photo-gallery";
import Lightbox from "react-images";
import ResponsivePlayer from "../global/responsive-player.js";

import wp from "../tools/wp-endpoint.js";

import Spinner from "../tools/spinner.js";

function ggT(z1, z2) {
  var m = z1;
  var n = z2;
  var r = 1;
  while (r != 0) {
    if (m < n) {
      var h = m;
      m = n;
      n = h;
    }
    r = m - n;
    m = n;
    n = r;
  }
  return m;
}

export default class Hypnopics extends React.Component {
  constructor(props) {
    super(props);

    this.perLoad = 4;

    this.state = {
      pdfUrl: undefined,
      images: [],
      mediaSorted: [],
      currentImage: 0,
      page: 1,
      galleryLoading: true,
      content: undefined,
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.loadMore = this.loadMore.bind(this);

    this.contentRef = React.createRef();

    wp.posts()
      .slug("pdfs")
      .perPage(1)
      .embed()
      .then(
        function (data) {
          if (data && data.length === 1) {
            this.setState({
              pdfUrl: data[0].acf["zahlen_daten_fakten_hypnopics"],
            });
          }
        }.bind(this)
      );

    wp.posts()
      .slug("hypnopics")
      .perPage(1)
      .embed()
      .then(
        function (data) {
          this.setState({
            content: data[0].content.rendered,
          });
          let imageOrder = data[0].acf.hypnopics.split(",");
          wp.media()
            .include(imageOrder)
            .perPage(100)
            .page(1)
            .then(
              function (media) {
                let mediaSorted = [];

                imageOrder.forEach(function (key) {
                  var found = false;
                  media = media.filter(function (item) {
                    if (!found && item.id == key) {
                      mediaSorted.push(item);
                      found = true;
                      return false;
                    } else return true;
                  });
                });

                let images = mediaSorted.slice(0, this.perLoad).map(function (image) {
                  let thumb = image["media_details"].sizes["medium_large"];
                  let ggt = ggT(thumb["width"], thumb["height"]);
                  return {
                    src: thumb["source_url"],
                    width: thumb["width"] / ggt,
                    height: thumb["height"] / ggt,
                  };
                });

                this.setState({
                  mediaSorted: mediaSorted,
                  images: images,
                  page: 1,
                  pages: parseInt(Math.ceil(mediaSorted.length / this.perLoad)),
                  galleryLoading: false,
                });
              }.bind(this)
            );
        }.bind(this)
      );
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  loadMore() {
    this.setState({ galleryLoading: true }, function () {
      let images = this.state.mediaSorted.slice(this.state.images.length, this.state.images.length + this.perLoad).map(function (image) {
        let thumb = image["media_details"].sizes["medium_large"];
        let ggt = ggT(thumb["width"], thumb["height"]);
        return {
          src: thumb["source_url"],
          width: thumb["width"] / ggt,
          height: thumb["height"] / ggt,
        };
      });

      this.setState({
        images: this.state.images.concat(images),
        page: this.state.page + 1,
        galleryLoading: false,
      });
    });
  }

  resizeIframes = () => {
    if (this.contentRef.current) {
      this.contentRef.current.querySelectorAll("iframe").forEach((iframe) => {
        iframe.width = this.contentRef.current.clientWidth;
        iframe.height = this.contentRef.current.clientWidth * 0.5625;
      });
    }
  };

  componentDidMount() {
    this.interval = setInterval(this.resizeIframes, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    let more = this.state.galleryLoading ? (
      <Spinner />
    ) : (
      <button className="default-button" onClick={this.loadMore}>
        Mehr Bilder...
      </button>
    );

    return (
      <div ref={this.contentRef}>
        <p>Kurz und knackig</p>

        {(this.state.content && <div dangerouslySetInnerHTML={{ __html: this.state.content }} />) || <Spinner />}

        <Gallery photos={this.state.images} onClick={this.openLightbox} columns={4} />
        {/*<Lightbox
          images={this.state.images}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
        />*/}
        {this.state.page < this.state.pages && more}
      </div>
    );
  }
}
